import {ModelTest, ResetRecoAreaData, TableObjData} from "../../util/interfaceData"
import {resetOcrTableData, resetRecoAreaData} from "../resetData"

export function modelTestInit() {
    return {type: "modelTestInit", payload: {}}
}

export function modelTestUpdate(updateData: ModelTest) {
    if (updateData.hasOwnProperty("loading") && updateData.loading !== null) {
        return {type: "loading", payload: "loading"}
    } else if (updateData.hasOwnProperty("stopLoading") && updateData.stopLoading !== null) {
        return {type: "stopLoading", payload: "stopLoading"}
    } else {
        if (updateData.markdownName === "normalTable") {
            return {
                type: "modelTestUpdate",
                payload: {
                    markdownName: updateData.markdownName,
                    normalTableJson: updateData.ocrData.ocrResult.ocrGeneralTableResultList,
                },
            }
        } else {
            let recognitionArea: ResetRecoAreaData = {
                recognitionArea: [],
                errorField: [],
            }
            let tableData: Array<TableObjData> = []
            if ("recognitionArea" in updateData.ocrData.ocrResult) {
                recognitionArea = resetRecoAreaData(updateData.ocrData.ocrResult.recognitionArea)
            }
            if (
                "table" in updateData.ocrData.ocrResult &&
                "tableField" in updateData &&
                updateData.ocrData.ocrResult["table"] !== null
            ) {
                tableData = resetOcrTableData(updateData.ocrData.ocrResult.table, updateData.tableField)
            }
            return {
                type: "modelTestUpdate",
                payload: {
                    ...recognitionArea,
                    markdownName: updateData.markdownName,
                    jsonData: updateData.jsonData ? updateData.jsonData : {},
                    table: tableData,
                },
            }
        }
    }
}

export function initData(initData: any) {
    return {type: "initData", payload: initData}
}

// eslint-disable-next-line no-shadow
export function errorMessage(errorMessage: string) {
    return {type: "error", payload: errorMessage}
}
